/* System defined core library */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { UtilityService } from '../../../../shared/services/utility.service';
import { AppointmentService } from '../../services/appointment/appointment.service';
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';

/* User defined models */
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { Program } from '../../../../shared/models/scheduling/program.model';

/* User defined enums/constants */
import { ComponentType } from '../../../../shared/enums/scheduling.enum';


@Component({
  selector: 'app-exam-selector',
  templateUrl: './exam-selector.component.html'
})
export class ExamSelectorComponent implements OnInit {

  /* User defined private/public variables  */
  public examFrm: FormGroup;
  public submitted: boolean = false;
  public errorMessage: string = "";

  /* Input-OutPut parameters decalartions */
  @Input() program: Program;
  @Input() inputLabel: string;
  @Input() public exams: Exam[] = [];
  @Input() public selectedExam: Exam;
  @Input() public targetFlow: string;
  @Output() getSelectedExam: EventEmitter<Exam> = new EventEmitter();

  /* Service subscriptions */
  exam$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private appointmentService: AppointmentService,
    private fb: FormBuilder,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {

  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.ExamSelectorComponent)) return;

    this.translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = this.selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        this.translate.use(languageCode);
      });

    this.examFrm = this.fb.group({
      'selectExam': new FormControl('', Validators.required),
    });

    // to disable exam dropdown when there's an exam sent via lpi
    if (this.selectedExam && this.selectedExamDetailService.lpiExamCode) {
      this.examFrm.controls['selectExam'].disable();
    }
  }

  /* disable exam if not schedulable using current method */
  disableExamInFlow(exam: Exam): boolean {
    return !this.appointmentService.canScheduleExamInFlow(exam);
  }

  anyExamsDisabled(): boolean {
    return this.exams.some(e => !this.appointmentService.canScheduleExamInFlow(e));
  }

  /* Set selected exam in shared service */
  changeExam(exam: Exam): void {
    this.selectedExam = exam;
    this.selectedExamDetailService.setExam(this.selectedExam);
    this.getSelectedExam.emit(this.selectedExam);
  }
}
